import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput, Button } from '@paypalcorp/pp-react';
import styles from '../Fastlane.module.less';

const ShippingAddressForm = ({
  shippingAddress: {
    name: { givenName: givenNameProp = '', familyName: familyNameProp = '' } = {},
    address: {
      addressLine1: addressLine1Prop = '',
      addressLine2: addressLine2Prop = '',
      adminArea2: adminArea2Prop = '',
      adminArea1: adminArea1Prop = '',
      postalCode: postalCodeProp = '',
      countryCode: countryCodeProp = ''
    } = {},
    phoneNumber: {
      telCountryCode: telCountryCodeProp = '',
      nationalNumber: nationalNumberProp = ''
    } = {}
  } = {},
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    givenName: givenNameProp,
    familyName: familyNameProp,
    addressLine1: addressLine1Prop,
    addressLine2: addressLine2Prop,
    adminArea2: adminArea2Prop,
    adminArea1: adminArea1Prop,
    postalCode: postalCodeProp,
    countryCode: countryCodeProp,
    telCountryCode: telCountryCodeProp,
    nationalNumber: nationalNumberProp
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      addressLine1,
      addressLine2,
      adminArea2,
      adminArea1,
      postalCode,
      countryCode,
      givenName,
      familyName,
      telCountryCode,
      nationalNumber
    } = formData;

    const formattedAddress = {
      address: {
        addressLine1,
        addressLine2,
        adminArea2,
        adminArea1,
        postalCode,
        countryCode
      },
      name: {
        givenName,
        familyName,
        fullName: [givenName, familyName].filter((field) => !!field).join(' ')
      },
      phoneNumber: {
        telCountryCode,
        nationalNumber
      }
    };

    onSubmit(formattedAddress);
  };
  return (
    <form className={styles.address_form} onSubmit={handleSubmit}>
      <div className={styles.address_form_field_container}>
        <TextInput
          type="text"
          name="givenName"
          label="First name"
          value={formData.givenName}
          onChange={handleChange}
          autoComplete="given-name"
          required
          className={styles.address_form_field}
        />
        <TextInput
          type="text"
          name="familyName"
          label="Last name"
          value={formData.familyName}
          onChange={handleChange}
          autoComplete="family-name"
          required
          className={styles.address_form_field}
        />
      </div>
      <TextInput
        type="text"
        name="addressLine1"
        value={formData.addressLine1}
        onChange={handleChange}
        autoComplete="address-line1"
        label="Address Line 1"
        required
        className={styles.address_form_field}
      />
      <TextInput
        type="text"
        name="addressLine2"
        label="Apt., ste., bldg. (optional)"
        autoComplete="address-line2"
        value={formData.addressLine2}
        onChange={handleChange}
        className={styles.address_form_field}
      />
      <div className={styles.address_form_field_container}>
        <TextInput
          type="text"
          name="adminArea2"
          autoComplete="address-level2"
          value={formData.adminArea2}
          onChange={handleChange}
          label="City"
          required
          className={styles.address_form_field}
        />
        <TextInput
          type="text"
          name="adminArea1"
          autoComplete="address-level1"
          value={formData.adminArea1}
          onChange={handleChange}
          label="State"
          required
          className={styles.address_form_field}
        />
      </div>
      <div className={styles.address_form_field_container}>
        <TextInput
          type="text"
          name="postalCode"
          value={formData.postalCode}
          onChange={handleChange}
          autoComplete="postal-code"
          label="ZIP code"
          required
          className={styles.address_form_field}
        />
        <TextInput
          name="countryCode"
          value={formData.countryCode}
          onChange={handleChange}
          autoComplete="country"
          label="Country (eg. US, GB)"
          required
          className={styles.address_form_field}
        />
      </div>
      <div className={styles.address_form_field_container}>
        <TextInput
          name="telCountryCode"
          type="tel"
          label="Country calling code"
          autoComplete="tel-country-code"
          onChange={handleChange}
          value={formData.telCountryCode}
          className={styles.address_form_field}
        />
        <TextInput
          name="nationalNumber"
          type="tel"
          label="Phone number"
          autoComplete="tel-national"
          onChange={handleChange}
          value={formData.nationalNumber}
          className={styles.address_form_field}
        />
      </div>
      <div className={styles.cta_button_container}>
        <Button type="submit">Submit</Button>
      </div>
    </form>
  );
};

export default ShippingAddressForm;

ShippingAddressForm.propTypes = {
  shippingAddress: PropTypes.object,
  onSubmit: PropTypes.func.isRequired
};

ShippingAddressForm.defaultProps = {
  shippingAddress: {}
};
